module.exports = __webpack_public_path__ + "static/images/components/Back/images/back-hover.04fd723e.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/back-hover.png
// module id = 2490
// module chunks = 11